import { Typography } from '@mui/material';

const Footer = () => {
  return (
    <div><br />
    <hr style={{width:'80%',color:'white'}}/><br />
    <Typography variant="body2" sx={{ fontSize: { xs: '0.6rem', md: '0.8rem' },textAlign:'center',color:'white', }}>
      © 2024 Globspot. Todos los derechos reservados.
    </Typography><br />
    </div>
  );
};

export default Footer;
